import Api from '@Contexts/Api';
import { useContext } from 'react';

const useApi = () => useContext(Api);

export default useApi;
